import { useCallback } from 'react';

import { Box, Grid, Text, useTheme } from '@simplywallst/ui-core';
import ChevronDownSmallSolid from '@simplywallst/ui-core/icons/ChevronDownSmallSolid';

import { ButtonRenderProps, Dropdown } from '@/components/Dropdown';
import { DropdownButton } from './styled';
import { tooltipContent } from '../../tooltipContent';
import { NarrativeValuatorTooltip } from '../NarrativeValuatorTooltip';

export type Props = {
  onChange: (value: number) => void;
  timePeriod: number;
};

const options = [
  { option: '3', label: '3 Years' },
  { option: '5', label: '5 Years' },
  { option: '10', label: '10 Years' },
];

export const EstimationPeriodDropdown = ({ onChange, timePeriod }: Props) => {
  const theme = useTheme();

  const dropdownButton = useCallback(
    ({
      onBlur,
      onFocus,
      onClick,
      innerRef,
      value,
      name,
    }: ButtonRenderProps) => {
      return (
        <DropdownButton
          styleType="softLink"
          alignIcon="right"
          onBlur={onBlur}
          onFocus={onFocus}
          onClick={onClick}
          ref={innerRef}
          data-cy-id={name}
        >
          <Grid templateColumns="auto 24px" alignItems="center">
            <Text as="span" typography="xSmallStrong" color="textSofter">
              {value}
            </Text>
            <ChevronDownSmallSolid fill={theme.color.textSofter} />
          </Grid>
        </DropdownButton>
      );
    },
    [theme.color.textSofter]
  );

  return (
    <Box backgroundColor="phantom" padding="x2">
      <Grid templateColumns="max-content max-content auto" alignItems="center">
        <Text as="span" typography="xSmallStrong" color="textSolid">
          Future estimation in
        </Text>
        <Dropdown
          name="narrative-valuator-time-period"
          displayType="block"
          align="right"
          options={options}
          value={timePeriod.toString()}
          onSelect={(value: string) => {
            onChange(parseInt(value, 10));
          }}
          buttonRender={dropdownButton}
        />

        <Grid justifyContent="flex-end">
          <NarrativeValuatorTooltip>
            {tooltipContent.valuation}
          </NarrativeValuatorTooltip>
        </Grid>
      </Grid>
    </Box>
  );
};
